import './index.css';
import './ttc_toast.css';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import App from './src/App';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday'; // Modern ESM import instead of 'require'

// Global Providers
import { AppStateProvider } from './src/context/appState'; // Your updated provider
import React from 'react';

// Initialize dayjs plugins
dayjs.extend(isToday);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement as HTMLElement);

root.render(
  <React.StrictMode>
    <AppStateProvider>
      <App />
      <ToastContainer />
    </AppStateProvider>
  </React.StrictMode>,
);
